import { environment as global } from './environment.global';

export const environment = {
    ...global,

    domain: 'itask.dev.nasbg.com',
    scheme: 'https',
    port: null,
    webSockets: {
        ... global.webSockets,

        wsHost: 'itask.dev.nasbg.com',
        wsPort: 80,
        wssPort: 443,
        wsPath: '/live'
    }
};
